import { ElasticSearchResponse, Testimony, TestimonyDocument } from '@shared/services/elastic-search/models';

export const testimoniesSerializer = (testimonies: ElasticSearchResponse<TestimonyDocument>): Testimony[] =>
  testimonies.hits.hits.map((testimony) => {
    const source = testimony._source;
    return {
      image: source?.image?.[0] ?? null!,
      url: source?.url?.[0] ?? '',
      author: source?.author?.[0] ?? '',
      text: source?.text?.[0] ?? '',
    };
  });
